import { useState } from "react";

import { useToggleUserProductRoleMutation } from "@sso/apis/userProducts";
import { Switch } from "@sso/ui/Switch";

interface UserProductToggleRoleProps {
  userId: string;
  softwareId: string;
  roleId: string;
  hasRole: boolean;
}

export const UserProductToggleRole = ({ userId, softwareId, roleId, hasRole }: UserProductToggleRoleProps) => {
  const [checked, setChecked] = useState(hasRole);
  const [toggleRole, { isLoading }] = useToggleUserProductRoleMutation();

  const handleOnChangeAccess = async (assign: boolean) => {
    setChecked(assign);
    try {
      await toggleRole({ userId, softwareId, roleId, assign }).unwrap();
    } catch (error) {
      setChecked(checked => !checked);
    }
  };

  return <Switch size="xs" loading={isLoading} value={checked} checked={checked} onChange={handleOnChangeAccess} />;
};
